<template lang="html">
  <div>
    <b-col md="12">
      <b-card style="padding:0px">
        <div style="background-color: black;width: 100%;height: 100%;display: block;position: absolute;left: 0px;top: 0px; opacity: 0.2" v-on:click="pkgRowsData = []; $refs.pkgTable.refresh()" v-show="pkgRowsData.length > 0">
          <p style="width: 100%;height: 100%;display: block;position: absolute;left: 35%;top: 37%; color:#ffffff; font-weight:bold; font-size:20px">패키지 포함 목록 선택중</p>
        </div>
        <div slot="header">주옵션 목록</div>
        <div class="opt-table">
          <b-table style="margin-bottom:0px"
            striped
            hover
            bordered
            selectable
            ref="optTable"
            :select-mode="selectMode"
            selectedVariant="success"
            :fields="fieldItems"
            :items="reportOptions.optItems"
            :busy="reportOptions.optItems == 0"
            @row-selected="optSelected">
            <div slot="table-busy" class="text-center my-2">
              <strong>데이터가 없습니다.</strong>
            </div>
            <template slot="rnum" slot-scope="data">
              <div>
                <label class="col-form-label">{{data.item.rnum}}</label>
              </div>
            </template>
            <template slot="opt_code" slot-scope="data">
              <div>
                <label class="col-form-label">{{data.item.opt_code}}</label>
              </div>
            </template>
            <template slot="name" slot-scope="data">
              <div>
                <label class="col-form-label">{{data.item.name}}</label>
              </div>
            </template>
            <template slot="price" slot-scope="data">
              <div style="text-align:left">
                <span style="padding-left:20px">보안 파일 : ￦ {{data.item.security_price}}</span></br>
                <span style="padding-left:20px">일반 파일 : ￦ {{data.item.normal_price}}</span></br>
              </div>
            </template>
            <template slot="reg_date" slot-scope="data">
              <div>
                <label class="col-form-label">{{data.item.reg_date}}</label>
              </div>
            </template>
          </b-table>
        </div>
      </b-card>
    </b-col>

    <div class="card" style="border: 0px; margin:-23px 0 -5px 0">
    	<div class="card-body" style="padding: 0px">
    		<div style="margin: 0px auto; display: block; width: 55%">
    			<p style="float: left; font-size: 55px" :style="optRowsData.length > 0 ? 'opacity: 0.2' : (optRowsData.length == 0 && pkgRowsData.length == 0) ? 'opacity: 0.2': ''">
            <!-- 주옵션으로 이동 -->
    				<a href="javascript:void(0)" v-on:click="optOptionsGo()" v-show="(optRowsData.length > 0 && pkgRowsData.length > 0) || (optRowsData.length == 0 && pkgRowsData.length > 0)"><i class="fa fa-hand-o-up fa-lg mt-4"></i></a>
            <i class="fa fa-hand-o-up fa-lg mt-4" v-show="optRowsData.length > 0 || (optRowsData.length == 0 && pkgRowsData.length == 0)"></i>
    			</p>
    			<p style="float: right; font-size: 55px" :style="pkgRowsData.length > 0 ? 'opacity: 0.2' : (optRowsData.length == 0 && pkgRowsData.length == 0) ? 'opacity: 0.2': ''">
            <!-- 패키지로 이동 -->
    				<a href="javascript:void(0)" v-on:click="pkgOptionsGo()" v-show="(optRowsData.length > 0 && pkgRowsData.length > 0) || (pkgRowsData.length == 0 && optRowsData.length > 0)"><i class="fa fa-hand-o-down fa-lg mt-4"></i></a>
            <i class="fa fa-hand-o-down fa-lg mt-4" v-show="pkgRowsData.length > 0  || (optRowsData.length == 0 && pkgRowsData.length == 0)"></i>
    			</p>
    		</div>
    	</div>
    </div>

    <b-col md="12">
      <b-card style="padding:0px">
        <div style="background-color: black;width: 100%;height: 100%;display: block;position: absolute;left: 0px;top: 0px; opacity: 0.2" v-on:click="optRowsData = []; $refs.optTable.refresh()" v-show="optRowsData.length > 0">
          <p style="width: 100%;height: 100%;display: block;position: absolute;left: 37%;top: 37%; color:#ffffff; font-weight:bold; font-size:20px">주옵션 목록 선택중</p>
        </div>
        <div slot="header">패키지 포함 목록</div>
        <div class="opt-table">
          <b-table style="margin-bottom:0px"
            striped
            hover
            bordered
            selectable
            ref="pkgTable"
            :select-mode="selectMode"
            selectedVariant="success"
            :fields="fieldItems"
            :items="reportOptions.pkgItems"
            :busy="reportOptions.pkgItems == 0"
            @row-selected="pkgSelected">
            <div slot="table-busy" class="text-center my-2">
              <strong>데이터가 없습니다.</strong>
            </div>
            <template slot="rnum" slot-scope="data">
              <div>
                <label class="col-form-label">{{data.item.rnum}}</label>
              </div>
            </template>
            <template slot="opt_code" slot-scope="data">
              <div>
                <label class="col-form-label">{{data.item.opt_code}}</label>
              </div>
            </template>
            <template slot="name" slot-scope="data">
              <div>
                <label class="col-form-label">{{data.item.name}}</label>
              </div>
            </template>
            <template slot="price" slot-scope="data">
              <div style="text-align:left">
                <span style="padding-left:20px">보안 파일 : ￦ {{data.item.security_price}}</span></br>
                <span style="padding-left:20px">일반 파일 : ￦ {{data.item.normal_price}}</span></br>
              </div>
            </template>
            <template slot="reg_date" slot-scope="data">
              <div>
                <label class="col-form-label">{{data.item.reg_date}}</label>
              </div>
            </template>
          </b-table>
        </div>
      </b-card>
    </b-col>

  </div>
</template>

<script>
export default {
  props: {
    reportOptions:{
      optItems: [],
      pkgItems: [],
      pkgOptList: []
    },
    formModal:null,
  },
  data(){
    return {
      selectMode: 'multi',
      optRowsData: [],
      pkgRowsData: [],
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          },
        }
      }, {
        'opt_code': {
          'label': '보고서코드',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'name': {
          'label': '옵션명',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'price': {
          'label': '소비자가',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }],
    }
  },
  mounted: function() {

  },
  watch: {
    formModal () {
      var self = this;
      self.optRowsData = [];
      self.pkgRowsData = [];
      self.$refs.optTable.refresh();
      self.$refs.pkgTable.refresh();
      console.log(self.reportOptions);
      if(self.formModal){
        self.reportOptions.optItems.forEach(function (el, idx, arr){
          el.rnum = (idx+1);
        });
      }
    },
  },
  methods:{
    optSelected(items) {
      this.optRowsData = items;
    },
    pkgSelected(items) {
      this.pkgRowsData = items;
    },
    optOptionsGo() {
      var self = this;
      self.pkgRowsData.forEach(function (el, idx, arr){
        self.reportOptions.pkgItems.forEach(function (t_el, t_idx, t_arr){
          if(el.opt_code == t_el.opt_code){
            self.reportOptions.pkgItems.splice(t_idx, 1);
          }
        });
        self.reportOptions.optItems.push(el);
      });
    },
    pkgOptionsGo() {
      var self = this;
      self.optRowsData.forEach(function (el, idx, arr){
        self.reportOptions.optItems.forEach(function (t_el, t_idx, t_arr){
          if(el.opt_code == t_el.opt_code){
            self.reportOptions.optItems.splice(t_idx, 1);
          }
        });
        self.reportOptions.pkgItems.push(el);
      });
    },
  }
}
</script>


<style scoped>
.formLabel{
  font-weight: 600;
}
.opt-table {
  max-height: 278px;
  overflow: auto;
}
.card-body {
  padding:0px
}
</style>



// WEBPACK FOOTER //
// src/views/contents/ReportOptModal.vue